import TableButton from 'components/common/Buttons/TableButton'
import Table from 'components/common/Table'
import { UpdateFormContainer } from 'components/admin/Forms/UpdateFormContainer'
import React, { useContext, useState } from 'react'
import { Roles } from 'utils/enums'
import { AdminDataContext } from 'context/AdminDataContext'
import ClientsSection from '../Clients'
import TranslatorsSection from '../Translators'

const SEARCH_OPTIONS = ['email', 'firstName', 'lastName']
const ORDER_OPTIONS = ['email', 'firstName', 'lastName']

const MediatorsSection = ({ getColumnForDeleting, disableAutoScroll }) => {
  const { mediators } = useContext(AdminDataContext)

  const [selectedMediator, setSelectedMediator] = useState(null)
  const [mediatorToModify, setMediatorToModify] = useState(null)

  const aditionalColumns = [
    {
      Header: 'Empresas',
      Cell: ({
        row: {
          original: {
            id, clients, firstName, lastName,
          },
        },
        cellCustomData,
      }) => {
        return (
          <TableButton
            selected={
              id === cellCustomData.selectedMediator?.id
              && cellCustomData.selectedMediator?.role === Roles.Client.role
            }
            clickHandler={() => {
              setSelectedMediator((ps) =>
                (ps?.id === id && ps?.role === Roles.Client.role
                  ? null
                  : {
                    endpoint: clients,
                    title: `${firstName} ${lastName}`,
                    id,
                    role: Roles.Client.role,
                  }))
            }}
          >
            Ver Empresas
          </TableButton>
        )
      },
    },
    {
      Header: 'Intérpretes',
      Cell: ({
        row: {
          original: {
            id, translators, firstName, lastName,
          },
        },
        cellCustomData,
      }) => {
        return (
          <TableButton
            selected={
              id === cellCustomData.selectedMediator?.id
              && cellCustomData.selectedMediator?.role === Roles.Translator.role
            }
            clickHandler={() => {
              setSelectedMediator((ps) =>
                (ps?.id === id && ps?.role === Roles.Translator.role
                  ? null
                  : {
                    endpoint: translators,
                    title: `${firstName} ${lastName}`,
                    id,
                    role: Roles.Translator.role,
                  }))
            }}
          >
            Ver Puestos
          </TableButton>
        )
      },
    },
    {
      Header: 'Editar',
      Cell: ({ row: { original }, cellCustomData }) => {
        return (
          <TableButton
            selected={original.id === cellCustomData.mediatorToModify?.id}
            clickHandler={() =>
              setMediatorToModify((ps) =>
                (ps?.id === original.id ? null : original))}
          >
            Editar
          </TableButton>
        )
      },
    },
    getColumnForDeleting(Roles.Mediator.mainPath),
  ]
  return (
    <>
      <div className='flex flex-col'>
        <Table
          title='Mediadores'
          tableData={mediators}
          endpoint='/admins/mediators'
          aditionalColumns={aditionalColumns}
          searchOptions={SEARCH_OPTIONS}
          orderOptions={ORDER_OPTIONS}
          cellCustomData={{ selectedMediator, mediatorToModify }}
          disableAutoScroll={disableAutoScroll}
        >
          {selectedMediator?.role === Roles.Client.role && (
            <ClientsSection
              ownerId={selectedMediator.id}
              endpoint={selectedMediator.endpoint}
              title={`Empresas de ${selectedMediator.title}`}
              getColumnForDeleting={getColumnForDeleting}
            />
          )}
          {selectedMediator?.role === Roles.Translator.role && (
            <TranslatorsSection
              ownerId={selectedMediator.id}
              endpoint={selectedMediator.endpoint}
              title={`Puestos de ${selectedMediator.title}`}
              getColumnForDeleting={getColumnForDeleting}
            />
          )}
        </Table>
      </div>
      {mediatorToModify && (
        <UpdateFormContainer
          roleObject={Roles.Mediator}
          initialValues={mediatorToModify}
          setSelectedUser={setMediatorToModify}
        />
      )}
    </>
  )
}

export default MediatorsSection
